<template>
    <div class="content">
        <div class="activity-rule wrap">
            <div class="rule-item">
                <div class="item-title vc"><i class="icon icon-line"></i>买二免一</div>
                <div class="item-content">2/13-2/29预定指定航次家庭三人房，限三人入住时，第三人船票全免。（巧虎房型及随机房型除外）-显示闪惠</div>
            </div>
            <div class="rule-item">
                <div class="item-title vc"><i class="icon icon-line"></i>第三第四人半价</div>
                <div class="item-content">2/13-2/29预定指定航次家庭三人房，限三人入住时，第三人船票全免。（巧虎房型及随机房型除外）-显示闪惠</div>
            </div>
            <div class="rule-item">
                <div class="item-title vc"><i class="icon icon-line"></i>每舱再减</div>
                <div class="item-content">2/13-2/29预定指定航次家庭三人房，限三人入住时，第三人船票全免。（巧虎房型及随机房型除外）-显示闪惠</div>
            </div>
            <div class="rule-item">
                <div class="item-title vc"><i class="icon icon-line"></i>巧虎主题房</div>
                <div class="item-content">2/13-2/29预定指定航次家庭三人房，限三人入住时，第三人船票全免。（巧虎房型及随机房型除外）-显示闪惠</div>
            </div>
            <div class="rule-item">
                <div class="item-title vc"><i class="icon icon-line"></i>第一第二人立减</div>
                <div class="item-content">2/13-2/29预定指定航次家庭三人房，限三人入住时，第三人船票全免。（巧虎房型及随机房型除外）-显示闪惠</div>
            </div>
            <div class="rule-item">
                <div class="item-title vc"><i class="icon icon-line"></i>优惠说明</div>
                <div class="item-content">2/13-2/29预定指定航次家庭三人房，限三人入住时，第三人船票全免。（巧虎房型及随机房型除外）-显示闪惠</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'activityRule',
        data: () => {
            return {}
        },
        beforeMount () {
            this.$router.replace('/member/index?showRec=true')
        },
        methods: {}
    }
</script>

<style lang="less" scoped>
    .page-title{
        color: #fff;
    }
    .activity-rule{
        padding-top: 1.20rem;
        .rule-item{
            padding-top: 0.24rem;
            .item-title{
                color: #4a90e2;
                .icon-line{
                    width: 0.08rem;
                    height: 0.26rem;
                    margin-right: 0.14rem;
                    background-color: #4a90e2;
                }
            }
            .item-content{
                padding-top: 0.20rem;
                line-height: 0.38rem;
            }
        }
    }
</style>
